import React from "react";
import "./PageIntro.css";

export default function PageIntro(props) {
  return (
    <div
      className="pageIntro"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url(${props.image})`,
        backgroundBlendMode: "multiply",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundAttachment: "fixed",
      }}
    >
      <h1>{props.text}</h1>
    </div>
  );
}
